import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconChevronRightStyle0 = cosmosIconCss;

const CosmosIconChevronRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconChevronRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '828849314f3caa88aa3566dea8b40cef8b3b5960', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6e372daf27a44e78139f866426beb1c560c4f6b1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '049ac3a48d04853f7ec80eb3eec369b0fc9358d2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.45 10.38 9.62 4.56a.48.48 0 0 0-.7 0l-.36.35a.51.51 0 0 0 0 .71l5.12 5.12-5.12 5.11a.51.51 0 0 0 0 .71l.36.35a.48.48 0 0 0 .7 0l5.83-5.82a.51.51 0 0 0 0-.71Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconChevronRightStyle0; }
}, [1, "cosmos-icon-chevron-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chevron-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chevron-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChevronRight$1);
            }
            break;
    } });
}

const CosmosIconChevronRight = CosmosIconChevronRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronRight, defineCustomElement };
